module.exports = __webpack_public_path__ + "img/icon_select_arrow_gray.b4732d23.svg";